import { useCallback, useRef, useState } from 'react';
import { parseDateFields } from '../../hooks/http/useHttpFetch';
import api, { FetchError } from '../../api/api';

export interface FormEntityUpsertDto {
  formTemplateId: number;
  version: number;
  statePath: string;
  data: any;
  isFinal: boolean;
  /**
   * duration in minutes spent on form state.
   */
  duration: number;
}

export function useUpsertFormEntityData(tableName: string) {
  const [upsertedEntityData, setUpsertedEntityData] = useState<any>();
  const [loading, setLoading] = useState<Boolean>(false);
  const [error, setError] = useState<FetchError>();

  const upsertEntityData = useCallback(
    async (formEntityUpsertDto: FormEntityUpsertDto) => {
      const maxRetries = 3;
      const retryDelay = 1000;
      setLoading(true);
      for (let attempt = 0; attempt < maxRetries; attempt++) {
        const result = await api.put(
          `forms/entities/${tableName}`,
          formEntityUpsertDto
        ).response;
        let json = result ? await result.json() : undefined;
        if (!result.ok) {
          if (attempt === maxRetries - 1) {
            setUpsertedEntityData(undefined);
            setError(json as FetchError);
            setLoading(false);
          }
          await new Promise(res => setTimeout(res, retryDelay));
        } else {
          if (json) json = parseDateFields(json);
          setUpsertedEntityData(json);
          setLoading(false);
          return;
        }
      }
    },
    [tableName]
  );

  return {
    upsertedEntityData,
    isUpsertingData: loading,
    upsertingDataError: error,
    upsertEntityData
  };
}
